import { TableChartConfigDto, BatterUsedPitchTypesChartDto } from 'types/CodegenReportTypes';
import Table, { Order } from 'components/Table/Table';
import { getDisplayedColumns, tableHeaders } from 'utilities/tableHeaders';

import { ChartProps } from 'utilities/chartIdToComponent';
import { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import useReportStore from 'hooks/PlayerReport/Batter/reportStore';
import PitchTypeTableCell from 'components/Table/PitchTypeTableCell';

export type BatterUsedPitchTypesChartColumn = keyof BatterUsedPitchTypesChartDto['batterUsedPitchTypes'][number];

const BatterUsedPitchTypesChart = ({
  chartData,
  isLoading,
  chartConfig,
}: ChartProps<BatterUsedPitchTypesChartDto, TableChartConfigDto>) => {
  const { t } = useTranslation();

  const [page, setPage] = useState(0);
  const [order, setOrder] = useState<Order>('desc');
  const [orderBy, setOrderBy] = useState<BatterUsedPitchTypesChartColumn | '' | 'id'>('');

  const { selectedConfgValues } = useReportStore();

  const rows = useMemo(
    () =>
      chartData?.batterUsedPitchTypes.map((row, i) => ({
        ...row,
        id: i.toString(),
      })) ?? [],
    [chartData?.batterUsedPitchTypes]
  );

  const columns = useMemo(() => {
    const displayedColumns = getDisplayedColumns<BatterUsedPitchTypesChartColumn>(chartConfig.visibleStats);
    const pitchTypeColumnNameKey = selectedConfgValues.pitchGrouping === 'Types' ? 'pitchType' : 'parentPitchType';

    return displayedColumns.map((column) => ({
      ...tableHeaders[column],
      field: column,
      headerName: column === 'pitchType' ? t(pitchTypeColumnNameKey) : t(column),
      headerShortName: column === 'pitchType' ? t('short.' + pitchTypeColumnNameKey) : t('short.' + column),
      sortable: true,
      renderCell: column === 'pitchType' ? (cellValue) => <PitchTypeTableCell pitchType={cellValue} /> : undefined,
    }));
  }, [chartConfig.visibleStats, selectedConfgValues.pitchGrouping]);

  return (
    <Table
      rows={rows}
      pageState={[page, setPage]}
      orderState={[order, setOrder]}
      orderByState={[orderBy, setOrderBy]}
      columns={columns}
      loading={isLoading}
      noFooter
      tileTable
    />
  );
};

export default BatterUsedPitchTypesChart;
